import { AddOutlined as AddOutlinedIcon, Clear, Search } from "@mui/icons-material";
import {
	Box,
	Button,
	FormControl,
	Grid,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	SelectChangeEvent,
	TextField,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import React from "react";

type ProfileOption = {
	value: string;
	label: string;
};

interface ToolbarPermissionsProps {
	busca: string;
	showSearch: boolean;
	onChangeBusca: (newText: string) => void;
	onSearch: () => void;
	onClearSearch: () => void;

	profileValue: string;
	showInputProfile: boolean;
	onChangeProfile: (profile: string) => void;
	profileOptions?: ProfileOption[];

	statusValue: string;
	showInputStatus: boolean;
	onChangeStatus: (status: string) => void;

	textoButtonNew: string;
	showButtonNew: boolean;
	onClickNovo: () => void;
	isButtonNewDisabled?: boolean;
}

export const ToolbarPermissions: React.FC<ToolbarPermissionsProps> = ({
	busca,
	showSearch,
	onChangeBusca,
	onSearch,
	onClearSearch,
	profileValue,
	showInputProfile,
	onChangeProfile,
	profileOptions,
	statusValue,
	showInputStatus,
	onChangeStatus,
	textoButtonNew,
	showButtonNew,
	onClickNovo,
	isButtonNewDisabled,
}) => {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const handleChangeProfile = (event: SelectChangeEvent) => {
		onChangeProfile(event.target.value as string);
	};

	const handleChangeStatus = (event: SelectChangeEvent) => {
		onChangeStatus(event.target.value as string);
	};

	const normalizedProfileOptions: ProfileOption[] = profileOptions && profileOptions.length > 0
		? profileOptions
		: [
			{ value: "admin", label: "Administrativo" },
			{ value: "estate", label: "Imobiliária" },
			{ value: "broker", label: "Parceiro" },
		];

	return (
		<Box component={Paper} display="flex" flexDirection="column" padding={2} gap={1} mx={1} elevation={0}>
			{/* Linha 1: filtros + botão novo */}
			<Grid container spacing={2} direction={isSmallScreen ? "column" : "row"} alignItems={isSmallScreen ? "stretch" : "center"}>
				{showInputProfile && (
					<Grid item xs={12} sm={6} md={3}>
						<FormControl fullWidth size="small">
							<InputLabel id="profile-permissions">Perfil</InputLabel>
							<Select
								labelId="profile-permissions"
								id="profile-permissions"
								fullWidth
								label="Perfil"
								value={profileValue || "Todos"}
								onChange={handleChangeProfile}
							>
								<MenuItem value="Todos">Todos</MenuItem>
								{normalizedProfileOptions.map((opt) => (
									<MenuItem key={opt.value} value={opt.value}>
										{opt.label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>
				)}

				{showInputStatus && (
					<Grid item xs={12} sm={6} md={2}>
						<FormControl fullWidth size="small">
							<InputLabel id="status-permissions">Status</InputLabel>
							<Select
								labelId="status-permissions"
								id="status-permissions"
								fullWidth
								label="Status"
								value={statusValue || "Todos"}
								onChange={handleChangeStatus}
							>
								<MenuItem value="Todos">Todos</MenuItem>
								<MenuItem value="active">Ativo</MenuItem>
								<MenuItem value="inactive">Inativo</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				)}

				{showButtonNew && (
					<Grid item xs={12} sm="auto" md="auto" sx={{ ml: { md: "auto" } }}>
						<Box display="flex" justifyContent={isSmallScreen ? "flex-start" : "flex-end"}>
							<Button
								variant="contained"
								color="primary"
								startIcon={<AddOutlinedIcon />}
								onClick={onClickNovo}
								disabled={isButtonNewDisabled}
							>
								{textoButtonNew}
							</Button>
						</Box>
					</Grid>
				)}
			</Grid>

			{/* Linha 2: pesquisa + botão pesquisar */}
			{showSearch && (
				<Grid container spacing={2} direction={isSmallScreen ? "column" : "row"} alignItems={isSmallScreen ? "stretch" : "center"}>
					<Grid item xs={12} sm={6} md={4}>
						<TextField
							fullWidth
							size="small"
							value={busca}
							placeholder="Pesquisar..."
							onChange={(e) => onChangeBusca(e.target.value)}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<Search />
									</InputAdornment>
								),
								endAdornment: (
									<InputAdornment position="end">
										<IconButton onClick={onClearSearch} disabled={!busca}>
											<Clear />
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
					</Grid>

					<Grid item xs={12} sm="auto" md="auto">
						<Box display="flex" justifyContent="flex-start" gap={1}>
							<Button variant="contained" onClick={onSearch}>
								Pesquisar
							</Button>
						</Box>
					</Grid>
				</Grid>
			)}
		</Box>
	);
};
